import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Booking from "@/pages/Booking";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminBookings from "@/pages/AdminBookings";
import AdminServices from "@/pages/AdminServices";
import AdminCalendar from "@/pages/AdminCalendar";
import AdminGallery from "@/pages/AdminGallery";
import Gallery from "@/pages/Gallery";
import Review from "@/pages/Review";
import ResumePayment from "@/pages/ResumePayment";
import PayBalance from "@/pages/PayBalance";
import MyBookings from "@/pages/MyBookings";
import QuoteRespond from "@/pages/QuoteRespond";
import Terms from "@/pages/Terms";
import RecurringConfirm from "@/pages/RecurringConfirm";
import AdminSubscriptions from "@/pages/AdminSubscriptions";
import AdminCallbacks from "@/pages/AdminCallbacks";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors theme="dark" position="top-right" />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/book" element={<Booking />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/review/:bookingId" element={<Review />} />
          <Route path="/my-bookings" element={<MyBookings />} />
          <Route path="/quote/:bookingId" element={<QuoteRespond />} />
          <Route path="/recurring/confirm" element={<RecurringConfirm />} />
          <Route path="/pay/:bookingId" element={<ResumePayment />} />
          <Route path="/pay-balance/:bookingId" element={<PayBalance />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="bookings" element={<AdminBookings />} />
            <Route path="callbacks" element={<AdminCallbacks />} />
            <Route path="calendar" element={<AdminCalendar />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="subscriptions" element={<AdminSubscriptions />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
